export default __webpack_public_path__ + "static/media/stock.7328e096.svg";